<template>
  <div>
    <Nav></Nav>

    <mdb-container class="page-title">
      <mdb-row class="mb-0">
        <mdb-col md="12">
          <h1>Pick a Challenge</h1>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container class="pick-a-challenge mt-3 mb-5">
      <mdb-row class="d-flex justify-content-between mb-4">
        <mdb-col class="text-center">
          <div class="challenge-circle">
            <div class="challenge-circle-inner">
              <h4>I don’t think selling is important</h4>
            </div>
          </div>
        </mdb-col>
        <mdb-col class="text-center">
          <div class="challenge-circle selected">
            <div class="challenge-circle-inner">
              <h4>I hate selling and I don’t think I am good at it</h4>
            </div>
          </div>
        </mdb-col>
        <mdb-col class="text-center">
          <div class="challenge-circle">
            <div class="challenge-circle-inner">
              <h4>I don’t know how to find clients</h4>
            </div>
          </div>
        </mdb-col>
        <mdb-col class="text-center">
          <div class="challenge-circle">
            <div class="challenge-circle-inner">
              <h4>How do I get more people to buy from me</h4>
            </div>
          </div>
        </mdb-col>
        <mdb-col class="text-center">
          <div class="challenge-circle">
            <div class="challenge-circle-inner">
              <h4>How do I sell more to existing clients</h4>
            </div>
          </div>
        </mdb-col>
        <mdb-col class="text-center">
          <div class="challenge-circle">
            <div class="challenge-circle-inner">
              <h4>How do I build a Sales Team</h4>
            </div>
          </div>
        </mdb-col>
        <mdb-col class="text-center">
          <div class="challenge-circle">
            <div class="challenge-circle-inner">
              <h4>How do I grow my Sales Team</h4>
            </div>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <!-- Content docks -->
    <mdb-container fluid class="bg-lightGrey py-2">
      <mdb-container class="content videos my-4">
        <mdb-row class="mb-4">
          <mdb-col class="text-left">
            <h2 class="h2-section">
              Videos
              <mdb-badge color="grey" class="ml-2">7</mdb-badge>
            </h2>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mb-4">
          <mdb-col md="3">
            <mdb-card>
              <mdb-card-image
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-1.jpg"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-badge pill color="purple" class="cat-badge">VIDEO</mdb-badge>
              <mdb-card-body>
                <mdb-card-title>Clients wants you to reduce the price!</mdb-card-title>
                <mdb-card-text>If you want to continuously improve your team’s cadence game, If you want to continuously improve your team’s cadence game, you need to understand all the variables in order to optimize them.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                in ATTRACT
                <span class="date">21.07.2019</span>
              </mdb-card-footer>
            </mdb-card>
          </mdb-col>
          <mdb-col col="3">
            <mdb-card>
              <mdb-card-image
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-2.jpg"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-card-body>
                <mdb-card-title>Client wants exclusivity</mdb-card-title>
                <mdb-card-text>If you want to continuously improve your team’s cadence game, you need to understand all the variables in order to optimize them.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                in ATTRACT
                <span class="date">21.07.2019</span>
              </mdb-card-footer>
            </mdb-card>
          </mdb-col>
          <mdb-col col="3">
            <mdb-card>
              <mdb-card-image
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-3.jpg"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-card-body>
                <mdb-card-title>Asking for referrals</mdb-card-title>
                <mdb-card-text>There’s a big difference between having the right tools and leveraging them effectively.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                in ATTRACT
                <span class="date">21.07.2019</span>
              </mdb-card-footer>
            </mdb-card>
          </mdb-col>
          <mdb-col col="3">
            <mdb-card>
              <mdb-card-image
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-4.jpg"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-card-body>
                <mdb-card-title>Buyer personality types</mdb-card-title>
                <mdb-card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                in ATTRACT
                <span class="date">21.07.2019</span>
              </mdb-card-footer>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-container>

      <mdb-container class="mt-5 mb-5 content podcasts">
        <mdb-row class="mb-4">
          <mdb-col class="text-left">
            <h2 class="h2-section">
              Podcasts
              <mdb-badge color="grey" class="ml-2">3</mdb-badge>
            </h2>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mb-4">
          <mdb-col md="3">
            <mdb-card>
              <mdb-card-body>
                <div class="top-info-text mb-2 mt-3">EPISODE #004</div>
                <mdb-card-title>Clients wants you to reduce the price!</mdb-card-title>
                <mdb-card-text>If you want to continuously improve your team’s cadence game, you need to understand all the variables in order to optimize them.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted class="date">21.07.2019</mdb-card-footer>
            </mdb-card>
          </mdb-col>
          <mdb-col col="3">
            <mdb-card>
              <mdb-card-body>
                <div class="top-info-text mb-2">EPISODE #003</div>
                <mdb-card-title>Client wants exclusivity</mdb-card-title>
                <mdb-card-text>If you want to continuously improve your team’s cadence game, you need to understand all the variables in order to optimize them.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted class="date">21.07.2019</mdb-card-footer>
            </mdb-card>
          </mdb-col>
          <mdb-col col="3">
            <mdb-card>
              <mdb-card-body>
                <div class="top-info-text mb-2">EPISODE #002</div>
                <mdb-card-title>Asking for referrals</mdb-card-title>
                <mdb-card-text>There’s a big difference between having the right tools and leveraging them effectively.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted class="date">21.07.2019</mdb-card-footer>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-container>

      <mdb-container class="mt-5 mb-5 content articles">
        <mdb-row class="mb-4">
          <mdb-col class="text-left">
            <h2 class="h2-section">
              Articles
              <mdb-badge color="grey" class="ml-2">3</mdb-badge>
            </h2>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mb-4">
          <mdb-col md="3">
            <mdb-card>
              <mdb-card-body>
                <div class="top-info-text mb-2">in: Attract</div>
                <mdb-card-title>Clients wants you to reduce the price!</mdb-card-title>
                <mdb-card-text>If you want to continuously improve your team’s cadence game, you need to understand all the variables in order to optimize them.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted class="date">21.07.2019</mdb-card-footer>
            </mdb-card>
          </mdb-col>
          <mdb-col col="3">
            <mdb-card>
              <mdb-card-body>
                <div class="top-info-text mb-2">in: Engage</div>
                <mdb-card-title>Client wants exclusivity</mdb-card-title>
                <mdb-card-text>If you want to continuously improve your team’s cadence game, you need to understand all the variables in order to optimize them.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted class="date">21.07.2019</mdb-card-footer>
            </mdb-card>
          </mdb-col>
          <mdb-col col="3">
            <mdb-card>
              <mdb-card-body>
                <div class="top-info-text mb-2">in: Engage</div>
                <mdb-card-title>Asking for referrals</mdb-card-title>
                <mdb-card-text>There’s a big difference between having the right tools and leveraging them effectively.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted class="date">21.07.2019</mdb-card-footer>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-container>

      <mdb-container class="mt-5 mb-5 content masterclasses">
        <mdb-row class="mb-4">
          <mdb-col class="text-left">
            <h2 class="h2-section">
              Masterclasses
              <mdb-badge color="grey" class="ml-2">1</mdb-badge>
            </h2>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mb-4">
          <mdb-col md="3">
            <mdb-card>
              <mdb-card-image
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-1.jpg"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-badge pill color="purple" class="cat-badge">VIDEO</mdb-badge>
              <mdb-card-body>
                <mdb-card-title>Clients wants you to reduce the price!</mdb-card-title>
                <mdb-card-text>If you want to continuously improve your team’s cadence game, you need to understand all the variables in order to optimize them.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                in ATTRACT
                <span class="date">21.07.2019</span>
              </mdb-card-footer>
            </mdb-card>
          </mdb-col>
          <mdb-col col="3">
            <mdb-card>
              <mdb-card-image
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-2.jpg"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-card-body>
                <mdb-card-title>Client wants exclusivity</mdb-card-title>
                <mdb-card-text>If you want to continuously improve your team’s cadence game, you need to understand all the variables in order to optimize them.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                in ATTRACT
                <span class="date">21.07.2019</span>
              </mdb-card-footer>
            </mdb-card>
          </mdb-col>
          <mdb-col col="3">
            <mdb-card>
              <mdb-card-image
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-3.jpg"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-card-body>
                <mdb-card-title>Asking for referrals</mdb-card-title>
                <mdb-card-text>There’s a big difference between having the right tools and leveraging them effectively.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                in ATTRACT
                <span class="date">21.07.2019</span>
              </mdb-card-footer>
            </mdb-card>
          </mdb-col>
          <mdb-col col="3">
            <mdb-card>
              <mdb-card-image
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/photo-4.jpg"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-card-body>
                <mdb-card-title>Buyer personality types</mdb-card-title>
                <mdb-card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                in ATTRACT
                <span class="date">21.07.2019</span>
              </mdb-card-footer>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </mdb-container>

    <mdb-container class="my-2 pt-5">
      <mdb-row class="mb-4">
        <mdb-col class="text-left">
          <h2 class="h2-section">Accelerate your learning with 1-on-1 Sales Coaching</h2>
        </mdb-col>
      </mdb-row>
      <mdb-row class="mb-4">
        <mdb-col md="12">
          <a href="#" class="a-card tile-video">
            <mdb-card class="home-tile tile-challenge card-image">
              <mdb-card-body>
                <mdb-card-title class="tile-title">Your challenge:</mdb-card-title>
                <div class="challenge">I hate selling and I don’t know if I’m good at it</div>
              </mdb-card-body>
              <mdb-card-footer small muted>12 videos | 3 podcasts | 7 articles</mdb-card-footer>
            </mdb-card>
          </a>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge
} from "mdbvue";

export default {
  name: "Challenges",
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge
  }
};
</script>

<style>
</style>
